import { jsx as _jsx } from "react/jsx-runtime";
import { t } from '@/core/localization';
import penToSquareIcon from '@/core/svg/fa/pen-to-square.svg';
import { forwardRef } from 'react';
import { ActionIconTemplate } from './ActionIconTemplate';
export const EditActionIcon = forwardRef((props, ref) => (_jsx(ActionIconTemplate, { ref: ref, ...props, icon: penToSquareIcon, defaultTitle: t('edit.label') })));
